import { createFileRoute } from '@tanstack/react-router';
import {
  createGroupBroadcastNewRoute,
  validateGroupBroadcastNewSearch,
} from '@/lib/route-factories/group-broadcast-route';

export const Route = createFileRoute(
  '/_authed/circles/$id/admin/broadcasts/new/',
)({
  validateSearch: validateGroupBroadcastNewSearch,
  ...createGroupBroadcastNewRoute({
    kind: 'circle',
    fromId: '/_authed/circles/$id/admin/broadcasts/new/',
  }),
});
